import TileActionResult from 'app/src/engine/action-results/TileActionResult';
import GearTile from 'app/src/engine/tiles/GearTile';
import { TileLocation } from 'app/src/engine/tiles/Tile';

export enum GearTileActionResultType {
	RotateClockwise,
	RotateCounterClockwise,
}

export default class GearTileActionResult extends TileActionResult {
	public type: GearTileActionResultType;

	constructor(gearTile: GearTile, location: TileLocation, type: GearTileActionResultType) {
		super(gearTile, location);

		this.type = type;
	}
}
